// src/contracts/strokes.ts
var STROKE_FORMAT_VERSION = 1;
var STROKE_TOOLS = ["pen", "pencil", "marker", "highlighter"];
var ANCHOR_KINDS = ["text", "block", "image", "drawing"];
var STROKE_HINTS = [
  "free",
  "underline",
  "strike",
  "circle",
  "highlight",
  "arrow",
  "scribble"
];
var POINT_FIELDS = 8;
var POINT_BYTES = POINT_FIELDS * 4;
var REFERENCE_FONT_SIZE = 17;
var REFERENCE_BLOCK_WIDTH = 600;
var ORPHAN_STROKE_PURGE_DAYS = 30;
var MIN_SEGMENT_POINTS = 2;

export { ANCHOR_KINDS, MIN_SEGMENT_POINTS, ORPHAN_STROKE_PURGE_DAYS, POINT_BYTES, POINT_FIELDS, REFERENCE_BLOCK_WIDTH, REFERENCE_FONT_SIZE, STROKE_FORMAT_VERSION, STROKE_HINTS, STROKE_TOOLS };
//# sourceMappingURL=chunk-SSS7IHSV.js.map
//# sourceMappingURL=chunk-SSS7IHSV.js.map